import ActionsTab from './ActionsTab';

export default ActionsTab;
